import './CSS_ke_log/CssForFIVEJS.css'
const Dastane =()=>{
return(
    <p id="pncilwala">दस्ताने पहनने से कीटाणु एक सतह से दूसरी सतह पर चले जाते हैं और उन्हें हटाते समय आपके हाथ दूषित हो जाते हैं। दस्ताने पहनने से हाथ साफ करने की जगह नहीं आती। स्वास्थ्य कार्यकर्ता केवल विशिष्ट कार्यों के लिए दस्ताने पहनते हैं।</p>
);
}

export default Dastane;

